import { gboReservationPath } from './session';

export const selectedCarClassDetailsPath = [...gboReservationPath, 'car_class_details'];
export const selectedCarClassesPath = [...gboReservationPath, 'car_classes'];
export const selectedCarClassCodePath = [...selectedCarClassDetailsPath, 'code'];
export const selectedCarClassVehicleRatesPath = [...selectedCarClassDetailsPath, 'vehicle_rates'];
export const selectedCarClassCouponsPath = [...selectedCarClassDetailsPath, 'coupons'];

export const vehicleReservationPath = [...gboReservationPath, 'vehicle'];
